module.exports = __webpack_public_path__ + "img/solutionhero_logo_erweitert_green.png";